import {useState} from "react";
import {NewsInterface} from "../../interfaces/core/NewsInterface";

interface NewsBlockProps {
    news: NewsInterface[]
}

const INITIAL_NEWS_COUNT = 4;
const MAX_NEWS_COUNT = 16;

export default function NewsBlock({news}: NewsBlockProps) {
    const [showAll, setShowAll] = useState(false);
    const displayNews = showAll ? news.slice(0, MAX_NEWS_COUNT) : news.slice(0, INITIAL_NEWS_COUNT);
    const shouldShowButton = news.length > INITIAL_NEWS_COUNT;

    const handleShowAll = () => {
        setShowAll(true);
    };

    const handleNewsClick = (human_url: string, id: number) => {
        window.location.href = `https://www.pride.ru/news/${id}/${human_url}`;
    };

    return (
        <div className="news-block">
            <div className="container">
                <div className="d-flex align-items-center justify-content-between news-block__head">
                    <h2 className="m-0 news-block__title t-two">
                        Новости
                    </h2>
                    {shouldShowButton && (
                        <button
                            className="btn btn-primary news-block__head-btn"
                            onClick={handleShowAll}
                            disabled={showAll}
                        >
                            Все новости
                        </button>
                    )}
                </div>

                <div className="row gx-md-6 gy-3 gx-svm-3 gy-sm-6 news-block__row">
                    {displayNews.map((item) => (
                        <div key={item.id} className="col-sm-6 col-xl-3 news-item">
                            <div className="d-flex flex-column news-item__body">
                                <div className="news-item__img">
                                    <img
                                        className="w-100 h-100 object-fit-cover"
                                        src={`https://www.pride.ru/public/images/news/${item.id}.jpg`}
                                        alt={item.title}
                                    />
                                </div>
                                <div className="d-flex flex-column news-item__content">
                                    <p className="news-item__date">
                                        {new Date(item.publish_date).toLocaleDateString('ru-RU')}
                                    </p>
                                    <div className="fw-bold news-item__title">
                                        {item.title}
                                    </div>
                                    <p className="news-item__text" dangerouslySetInnerHTML={{__html: item.predescription}} />
                                    <button
                                        className="btn btn-primary big news-item__btn"
                                        onClick={() => handleNewsClick(item.human_url, item.id)}
                                    >
                                        Подробнее →
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}